import InfoOutlineRoundedIcon from '@mui/icons-material/InfoOutlineRounded'
import { Stack, Typography, type SvgIconTypeMap } from '@mui/material'
import type { OverridableComponent } from '@mui/material/OverridableComponent'

/**
 * Estado vacío honesto (sección 27 del encargo) — sin card pesada, sin
 * ilustración decorativa. Mismo espíritu que `ModulePlaceholder` existente
 * pero editorial (sin Card) para encajar en superficies densas de V2.
 * Nunca invocar con un mensaje que implique un dato — solo con las frases
 * honestas ya establecidas en GOVIA: "Sin alertas críticas actualmente",
 * "No existe evidencia suficiente para calcular tendencia", etc.
 */
export function EmptyIntelligenceState({
  message,
  icon: Icon = InfoOutlineRoundedIcon,
}: {
  message: string
  icon?: OverridableComponent<SvgIconTypeMap>
}) {
  return (
    <Stack alignItems="center" spacing={1} sx={{ py: 4, textAlign: 'center' }}>
      <Icon sx={{ color: 'text.disabled', fontSize: 22 }} />
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
    </Stack>
  )
}
